import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/nathan/Documents/GitHub/wmn-cms-docs/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "edit-the-hub-page"
    }}>{`Edit the hub page`}</h1>
    <p>{`Documentation for editing the `}<a parentName="p" {...{
        "href": "https://beta.wmnetwork.co.uk/major-roadworks-and-events/",
        "title": "Major roadworks and events"
      }}>{`main hub page`}</a>{`.`}</p>
    <p>{`On this page the following can be edited or added:`}</p>
    <ol>
      <li parentName="ol">{`Related content`}</li>
      <li parentName="ol">{`Add Travel tips`}</li>
    </ol>
    <h2 {...{
      "id": "add-related-content-links"
    }}>{`Add Related Content Links`}</h2>
    <p><img alt="Related content" src={require("../../../public/pages/major-works/main-hub/major-works-main-hub-4.png")} /></p>
    <ol>
      <li parentName="ol">{`Open the hub page in Umbraco:`}</li>
    </ol>
    <p>{`West Midlands Network > Major roadworks and events`}</p>
    <p><img alt="Major Works main Hub page" src={require("../../../public/pages/major-works/main-hub/content-major-works.png")} /></p>
    <ol {...{
      "start": 2
    }}>
      <li parentName="ol">{`Open the hub page in Umbraco:`}</li>
    </ol>
    <p>{`Make sure you have the "Sidebar" tab selected`}</p>
    <p><img alt="Add related content links" src={require("../../../public/pages/major-works/main-hub/related-content.png")} /></p>
    <ol {...{
      "start": 3
    }}>
      <li parentName="ol">{`Add Links`}</li>
    </ol>
    <p>{`You can add related links by clicking on the "Add" button. There is no limit to the amount you can add.`}</p>
    <p><img alt="Add a Link" src={require("../../../public/pages/major-works/main-hub/related-content-add-link.png")} /></p>
    <p>{`See documentation on `}<a parentName="p" {...{
        "href": "/wmn-cms-docs/cms/adding-links/",
        "title": "Link Documentation"
      }}>{`adding links`}</a>{`.`}</p>
    <h2 {...{
      "id": "add-travel-tips"
    }}>{`Add Travel Tips`}</h2>
    <p>{`You can select which travel tips to display but in order to add or edit them `}<a parentName="p" {...{
        "href": "/wmn-cms-docs/major-roadworks-and-events/add-travel-tips",
        "title": "Add or edit Travel Tips"
      }}>{`follow the Travel Tips documentation`}</a>{`.`}</p>
    <ol>
      <li parentName="ol">{`On the Major roadworks and events page click on the "Travel Tips" tab.`}</li>
    </ol>
    <p><img alt="Add Travel Tips" src={require("../../../public/pages/major-works/travel-tips/travel-tips-add-tab.png")} /></p>
    <ol {...{
      "start": 2
    }}>
      <li parentName="ol">{`Click on the "Add" button which will reveal an overlay.`}</li>
    </ol>
    <p><img alt="Add Travel Tips" src={require("../../../public/pages/major-works/travel-tips/travel-tips-add-overlay.png")} /></p>
    <ol {...{
      "start": 3
    }}>
      <li parentName="ol">{`Select the category by clicking on the triangle to the left of the category title.`}</li>
    </ol>
    <p><img alt="Add Travel Tips" src={require("../../../public/pages/major-works/travel-tips/travel-tips-add-overlay-arrow.png")} /></p>
    <ol {...{
      "start": 4
    }}>
      <li parentName="ol">{`Select the travel tips oyu want displayed`}</li>
    </ol>
    <p><img alt="Add Travel Tips" src={require("../../../public/pages/major-works/travel-tips/travel-tips-add-select.png")} /></p>
    <p>{`Tip: You can select tips from another category by clicking on the back link and then selecting a category.`}</p>
    <p>{`Theres a maximum of 10 tips that you can add.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      